import React, { useState, useEffect, useMemo, useCallback } from 'react';
import httpClient from '@assets/js/api/httpClient.js';

const CompFmtSelectbox = ({
    attrs,
    onChange,
    onBlur,
    grpCd = null,
    rfrs1 = null,
    rfrs2 = null,
    includeCdList = null,
    notIncludeCdList = null,
    orderby = null,
    selectType = null,
    customParams = {},
    defaultValue = null,
}) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const {
        id,
        label,
        value = '',
        required = '',
        disabled = false,
        classCol = 'col-12',
    } = attrs;

    // Determine the actual value to use (priority: value from attrs > defaultValue prop > empty string)
    const selectValue = value || defaultValue || '';

    // customParams를 JSON 문자열로 변환하여 의존성 관리
    const customParamsString = useMemo(() => {
        return JSON.stringify(customParams);
    }, [customParams]);

    // fetchOptions를 useCallback으로 메모이제이션
    const fetchOptions = useCallback(async () => {
            setLoading(true);
            setError(null);
            
            try {
                let requestParams = {
                    grpCd : grpCd,
                    rfrs1 : rfrs1,
                    rfrs2 : rfrs2,
                    includeCdList : includeCdList,
                    notIncludeCdList : notIncludeCdList,
                    orderby : orderby,
                    ...customParams  // customParams 병합
                };

                let URI = '/common/code/list';
                const OTH_CODE = {
                    DVSNCD    : '/common/code/dvsn/list',
                    DVSNGRP   : '/common/code/dvsngrp/list',
                    SUPPTSGRP : '/common/code/supptsgrp/list',
                    SUPPTSCD  : '/common/code/suppts/list',
                    WETCLSGRP : '/common/code/wetclsgrp/list',
                    WETCLSCD  : '/common/code/wetcls/list',
                    COMPT     : '/common/code/comptcd/list',
                };
                if (grpCd in OTH_CODE) {
                    URI = OTH_CODE[grpCd];
                }

                const response = await httpClient.post(URI, requestParams);
                let fetchedOptions = response.data || [];

                // console.log('fetchedOptions', fetchedOptions);
    
                setOptions(fetchedOptions.dataList || []);
            } catch (err) {
                console.error('Error fetching options:', err);
                setError(err.message);
                setOptions([]);
            } finally {
                setLoading(false);
            }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grpCd, rfrs1, rfrs2, includeCdList, notIncludeCdList, orderby, customParamsString]);

    useEffect(() => {

        // grpCd가 있고, customParams가 비어있거나 유효한 값이 있을 때 조회
        if (grpCd) {
            // customParams가 있는 경우, 필요한 파라미터가 있는지 확인
            if (Object.keys(customParams).length > 0) {
                // customParams에 필요한 값들이 있는지 확인
                const hasRequiredParams = Object.values(customParams).some(value => value);
                if (hasRequiredParams) {
                    fetchOptions();
                } else {
                    // 필요한 파라미터가 없으면 옵션 초기화
                    setOptions([]);
                }
            } else {
                // customParams가 없는 일반적인 경우
                fetchOptions();
            }
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grpCd, rfrs1, rfrs2, includeCdList, notIncludeCdList, orderby, customParamsString, fetchOptions]);

    return (
        <div className={classCol}>
            <label htmlFor={id} className="form-label">
                {label}
            </label>
            <div className="input-group has-validation">
                {required ? (<span className="input-group-text">*</span>) : (<></>)}
                <select
                    className={'form-select'}
                    id={id}
                    value={selectValue}
                    disabled={disabled || loading}
                    required={required}
                    onChange={onChange}
                    onBlur={onBlur}
                >
                    {selectType === 'S' ? (
                        <option value="">-선택-</option>
                    ): selectType === 'A' ? (
                        <option value="">-전체-</option>
                    ): (
                        <></>
                    )}
                    {loading && (
                        <option value="">로딩 중...</option>
                    )}
                    {error && (
                        <option value="">오류 발생</option>
                    )}
                    {!loading && !error && options != null && options.length > 0 && options.map((option) => (
                        <option key={option.code} value={option.code}>
                            {option.codeNm}
                        </option>
                    ))}
                </select>
                {required ? (<div className="invalid-feedback"></div>) : (<></>)}
            </div>
        </div>
    );
};

export default CompFmtSelectbox;